export default __webpack_public_path__ + "static/media/noise-aware.32bde539.svg";